module.exports = __webpack_public_path__ + "img/evaluation.32f9f1b5.png";